<script lang="ts">
  import {onMount} from 'svelte';
  import {preview} from '../../store';
  let counter = 0;
  const renderChanges = ['videoFade'];
  let localState = {};

  function compareObjectDifference(object1: any, object2: any): string[] {
    let difference = [];
    for (let key in object1) {
      if (object1[key] !== object2[key]) {
        difference.push(key);
      }
    }
    return difference;
  }

  function checkIfAnyArrayElementsAreSame(arr1: string[], arr2: string[]): string[] {
    return arr1.filter(value => arr2.includes(value));
  }

  preview.subscribe(store => {
    if (Object.keys(localState).length == 0) return (localState = store);
    const differences = compareObjectDifference(store, localState);
    //console.log('Preview Change', counter);
    counter++;
    if (differences.length > 0) {
      const intersect = checkIfAnyArrayElementsAreSame(differences, renderChanges);
      //console.log('Intersected values:', differences);
    }

    localState = store;
  });

  onMount(() => {
    localState = $preview;
  });
</script>

<div id="render-manager"></div>
